import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import MapIcon from '@mui/icons-material/Map';

function Welcome() {
  return (
    <Box id="welcome" sx={{ backgroundColor: "rgb(255, 255, 255);" }}>
      <Container sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 4
      }}>
        <Stack spacing={2} useFlexGap sx={{ alignItems: "center" }}>
          <Typography variant="h4" component="h2">Upptäck dina lokala pärlor nära dig!</Typography>
          <Typography>Letar du efter unika gårdsbutiker, mysiga caféer eller charmiga loppisar? Med Lokala Pärlor kan du enkelt hitta och utforska allt från second-hand-butiker och gårdsbagerier till konstgallerier, trädgårdsodlingar och genuint hantverk. Stöd småföretag, upptäck nya favoritställen och njut av närproducerade produkter – allt samlat i en smidig app!</Typography>
          <Typography>Att handla lokalt gör skillnad – både för miljön och för de små företagen som håller landsbygden och våra städer levande. Genom att välja närproducerat får du högkvalitativa produkter samtidigt som du stöttar lokala entreprenörer, minskar transportutsläpp och bidrar till en mer hållbar framtid.</Typography>
          <Typography>Oavsett om du vill fynda vintage, smaka nybakat surdegsbröd, handla lokalt hantverk eller inspireras av konstnärer och odlare, så hjälper Lokala Pärlor dig att hitta rätt. Ladda ner appen idag och börja din resa genom det bästa din region har att erbjuda!</Typography>
          <Button variant="contained" LinkComponent={Link} to="/map" startIcon={<MapIcon />} >
            Hitta dina lokala pärlor
          </Button>
        </Stack>
      </Container>
    </Box>
  )
}

export default Welcome;